import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';
import 'react-toastify/dist/ReactToastify.css';
import { NotificationsFiltersValuesStateType } from './types';

const initialState: NotificationsFiltersValuesStateType = {
  days: '0',
  startDateTime: moment().startOf('day').format('yyyy-MM-DD HH:mm:ss'),
  finalDateTime: moment().endOf('day').format('yyyy-MM-DD HH:mm:ss'),
  plate: '',
  notificationId: '',
  notificationUserId: '',
  paymentOriginId: '0',
  situationId: '0',
  routeAreaId: '0',
  routeId: '0',
  userName: '',
  serviceOrderOrigin: '0',
  print: '0',
};

export const notificationsFiltersValuesSlice = createSlice({
  name: 'notificationsFiltersValues',
  initialState,
  reducers: {
    setNotificationsFiltersValues(
      state,
      action: PayloadAction<NotificationsFiltersValuesStateType>,
    ) {
      state.days = action.payload.days;
      state.startDateTime = action.payload.startDateTime;
      state.finalDateTime = action.payload.finalDateTime;
      state.plate = action.payload.plate;
      state.notificationId = action.payload.notificationId;
      state.notificationUserId = action.payload.notificationUserId;
      state.paymentOriginId = action.payload.paymentOriginId;
      state.situationId = action.payload.situationId;
      state.routeId = action.payload.routeId;
      state.userName = action.payload.userName;
      state.serviceOrderOrigin = action.payload.serviceOrderOrigin;
      state.routeAreaId = action.payload.routeAreaId;
      state.print = action.payload.print;
    },
    resetNotificationsFiltersValues(state) {
      state.days = '0';
      state.startDateTime = moment()
        .startOf('day')
        .format('yyyy-MM-DD HH:mm:ss');
      state.finalDateTime = moment().endOf('day').format('yyyy-MM-DD HH:mm:ss');
      state.plate = '';
      state.notificationId = '';
      state.notificationUserId = '';
      state.paymentOriginId = '';
      state.situationId = '0';
      state.routeId = '0';
      state.userName = '';
      state.serviceOrderOrigin = '0';
      state.print = '0';
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setNotificationsFiltersValues,
  resetNotificationsFiltersValues,
} = notificationsFiltersValuesSlice.actions;

// // now available:
// filtersValuesSlice.actions.setNotificationsFiltersValues();
// // also available:
// filtersValuesSlice.caseReducers.increment(0, { type: 'increment', payload: 5 });